import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';

export default function RefundPolicyPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <section className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-sm font-semibold text-primary-500 uppercase tracking-widest mb-3">
              AIVO SOLUTION SDN BHD
            </p>
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
              Refund Policy
            </h1>
            <p className="mt-3 text-sm text-foreground-500">Last updated: July 7, 2026</p>
          </div>

          <div className="prose prose-foreground max-w-none space-y-6 text-sm text-foreground-700 leading-relaxed">
            <div className="bg-red-50 border border-red-200 rounded-lg p-6 mb-8">
              <p className="text-base font-semibold text-red-800 mb-2">
                <i className="ri-error-warning-line w-5 h-5 inline-flex items-center justify-center mr-2" />
                Non-Refundable Policy
              </p>
              <p className="text-red-700">
                All sales are final. We do not offer refunds, exchanges, or cancellations under any circumstances.
              </p>
            </div>

            <p>
              At <strong>AIVO SOLUTION SDN BHD</strong>, operating under the brand <strong>ggcourse</strong>, we are committed to delivering high-quality AI education through our digital courses and materials. Due to the digital nature of our products, we maintain a strict <strong>non-refundable policy</strong>.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-950 mt-8 mb-3">1. No Refunds</h2>
            <p>
              All purchases made through our website at ggcourse.com are <strong>final and non-refundable</strong>. This applies to:
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>All individual courses.</li>
              <li>The Complete AI Mastery Bundle.</li>
              <li>Any promotional, discounted, or bundled offerings.</li>
              <li>Purchases made via any payment method accepted on our platform.</li>
            </ul>

            <h2 className="text-xl font-heading font-bold text-foreground-950 mt-8 mb-3">2. Why This Policy Exists</h2>
            <p>
              Our courses are <strong>digital products</strong> delivered instantly upon purchase. Once you gain access to the course content, videos, templates, and project files, the knowledge and materials cannot be returned. This is consistent with standard industry practice for digital educational products, as digital goods are deemed consumed immediately upon access.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-950 mt-8 mb-3">3. Exceptional Circumstances</h2>
            <p>
              In extremely rare cases of <strong>proven technical failure</strong> on our part — such as the course content being completely inaccessible for an extended period due to a platform outage — we may, at our sole discretion, consider offering a <strong>replacement or store credit</strong>. This does not constitute a refund. Each case will be evaluated individually and our decision shall be final.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-950 mt-8 mb-3">4. Chargebacks &amp; Disputes</h2>
            <p>
              By making a purchase, you agree not to initiate any <strong>chargeback, payment dispute, or reversal</strong> with your bank or payment provider without first contacting us. Any chargeback initiated in violation of this policy may result in immediate termination of your account and permanent revocation of access to all course content without any compensation.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-950 mt-8 mb-3">5. Questions Before Purchase</h2>
            <p>
              We encourage you to review the course descriptions, previews, and curriculum details on our <Link to="/pricing" className="text-primary-500 hover:text-primary-600 underline">Pricing page</Link> before making a purchase. If you have any questions about what is included, please contact us at <strong>admin@ggcourse.com</strong> — we are happy to help you make an informed decision.
            </p>

            <h2 className="text-xl font-heading font-bold text-foreground-950 mt-8 mb-3">6. Contact Us</h2>
            <p>
              If you have any questions about this Refund Policy, please contact us at:
            </p>
            <p>
              <strong>AIVO SOLUTION SDN BHD</strong><br />
              Email: admin@ggcourse.com<br />
              Address: Level 8, Tower A, Menara UOA Bangsar, No. 5 Jalan Bangsar Utama 1, 59000 Kuala Lumpur, Malaysia
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}